import GridView from "./grids/gridView";
import PropTypes from "prop-types";
import {useContext, useEffect} from "react";
import {CartContext} from "../../pages/shop";
import {Show, SignInButton, SignUpButton, UserButton} from "@clerk/react";


export default function ALaCartaComponent(props) {
    const descriptions = [
        "Freedom from monthly payments. Know what you're paying for.",
        "This is the second component description. It will mention the pain points and the ways to change."
    ]

    const {cartData, setCartData, allProjects} = useContext(CartContext)


// Clerk Account Management
    /*
    TODO:
        1. Put all services (outcomes) on this page
            a. Make it Shopify focused
        2. SEO Package complete
            a. Segmented into services or date in business (Shopify, WooCommerce, etc or <1 yr, 1-2 yrs, etc)
        3. Build the cart functionality and the cart page
        4. Checkout page (Connect to stripe - change the name on the stripe account?)
     */

    return (
        <div>

            <div className="flex items-center justify-center w-full">
                <div className="max-body-width">
                    <div className="mt-20">
                        <section className="container container-wide">
                            <h2 className="wp-block-heading flex justify-center items-center text-center custom-font font-extrabold">
                                <div>
                                    NO SUBSCRIPTIONS!
                                </div>
                            </h2>

                            <p className="mt-4 text-center custom-font font-light text-3xl">
                                Get comfortable with focused SEO strategies designed to increase your visibility.
                                <span className="text-purple-500"> Pay by the job! </span> Our pricing is transparent: a
                                single, flat fee for a complete plan,
                                freeing you from complex monthly contracts. Prefer an ongoing retainer?{" "}
                                <a target="_blank" href="/seo-retainer" className="font-ligh">Explore that option here.</a>
                            </p>

                        </section>
                    </div>

                    <div className="flex flex-col gap-y-32 mt-48">
                        <GridView
                            projects={allProjects["01"]["projects"]}
                            subtitle={`"I need expert SEO results, but I have limited time or experience."`}
                            sectionTitle="A PROFESSIONAL'S SETUP"
                            generalCTA={() => {
                                window.open("/services/setup", "_blank")
                            }}
                            description="Perfect for beginners or anyone starting fresh. We handle the entire process,
                            requiring minimal effort from you. Beginners start here!"

                        />

                        <div>
                            <p>
                                {/*{descriptions[1]}*/}
                            </p>

                            <GridView
                                projects={allProjects["02"]["projects"]}
                                subtitle={`"BELIEVE IN YOURSELF."`}
                                generalCTA={() => {
                                    window.open("/services/onsite-seo")
                                }}
                                sectionTitle="EXTENDED SEO"
                                description="If you've worked on SEO before and need minor polishing."
                            />
                        </div>

                        <div>
                            <p>
                                {/*{descriptions[1]}*/}
                            </p>

                            <GridView
                                projects={allProjects["03"]["projects"]}
                                subtitle={`"LET'S WIN THIS!"`}
                                generalCTA={() => {
                                    window.open("/services/technical")
                                }}
                                sectionTitle="TECHNICAL SEO"
                                description="Add SEO elements and go the extra mile."
                            />
                        </div>


                        <div>
                            <p>
                                {/*{descriptions[1]}*/}
                            </p>

                            <GridView
                                projects={allProjects["04"]["projects"]} title="BELIEVE IN YOURSELF AND YOUR ABILITIES"
                                generalCTA={() => {
                                    window.open("/services/seo-research")
                                }}
                                subtitle="Direct marketing efforts to boost your discovery"
                                sectionTitle="Content & Distribution" description="We help you leverage your existing audience to directly boost your site's organic search performance and authority."
                            />
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}


ALaCartaComponent.propTypes = {
    indexID: PropTypes.string,
}